import * as React from "react";
import { ButtonPrimary } from "@grandvisionhq/iris-ui";
/* empty css                  */
const CallToAction = ({
  formId,
  label,
  isLoading,
  isSmallScreen,
  onClick
}) => /* @__PURE__ */ React.createElement(
  ButtonPrimary,
  {
    type: "submit",
    "data-t": "cta-button",
    form: formId,
    isLoading,
    className: "configurator-footer-cta",
    onPress: onClick
  },
  label
);
export {
  CallToAction
};
//# sourceMappingURL=CallToAction.js.map
